import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"pause\">\n<path d=\"M10,21H6c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v16C11,20.6,10.6,21,10,21z M7,19h2V5H7V19z\" />\n<path d=\"M18,21h-4c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v16C19,20.6,18.6,21,18,21z M15,19h2V5h-2V19z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol